/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskItemDto } from './TaskItemDto';
import {
    TaskItemDtoFromJSON,
    TaskItemDtoFromJSONTyped,
    TaskItemDtoToJSON,
} from './TaskItemDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfTaskItemDto
 */
export interface ODataPostProcessedResultsOfTaskItemDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTaskItemDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TaskItemDto>}
     * @memberof ODataPostProcessedResultsOfTaskItemDto
     */
    value?: Array<TaskItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfTaskItemDto
     */
    $type?: ODataPostProcessedResultsOfTaskItemDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfTaskItemDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfTaskItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfTaskItemDtoTypeEnum = typeof ODataPostProcessedResultsOfTaskItemDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfTaskItemDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfTaskItemDto interface.
 */
export function instanceOfODataPostProcessedResultsOfTaskItemDto(value?: unknown): value is ODataPostProcessedResultsOfTaskItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfTaskItemDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfTaskItemDtoFromJSON(json: any): ODataPostProcessedResultsOfTaskItemDto {
    return ODataPostProcessedResultsOfTaskItemDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfTaskItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfTaskItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(TaskItemDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfTaskItemDtoToJSON(value?: ODataPostProcessedResultsOfTaskItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(TaskItemDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

